import { differenceInYears, parse } from 'date-fns'

export default function age(val) {
	const parsed = parse(val, 'MM/dd/yyyy', (new Date()))
	return Math.abs(differenceInYears(parsed, (new Date())))
}
